'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var DeliveryIcon = function (props) {
    var className = props.className;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '' });
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "currentColor" }, svgProps),
            React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 0V5H17L20 9V13.9988H18.9502C18.719 15.1405 17.7099 16 16.5 16C15.2901 16 14.281 15.1405 14.0498 13.9988H6.95023C6.71904 15.1405 5.70989 16 4.5 16C3.29011 16 2.28096 15.1405 2.04977 13.9988H0V0H14ZM18.9499 12.9995C18.7181 11.8586 17.7093 11 16.5 11C15.2907 11 14.2819 11.8586 14.0501 12.9995H14.0025V6H16.5L19 9.29446V12.9995H18.9499ZM13 12.9995H6.94989C6.71806 11.8586 5.7093 11 4.5 11C3.2907 11 2.28194 11.8586 2.05011 12.9995H1.01875L1 0.998723L13 1V12.9995ZM6 13.5C6 14.3284 5.32843 15 4.5 15C3.67157 15 3 14.3284 3 13.5C3 12.6716 3.67157 12 4.5 12C5.32843 12 6 12.6716 6 13.5ZM16.5 15C17.3284 15 18 14.3284 18 13.5C18 12.6716 17.3284 12 16.5 12C15.6716 12 15 12.6716 15 13.5C15 14.3284 15.6716 15 16.5 15Z" }))));
};

exports.default = DeliveryIcon;
//# sourceMappingURL=index.js.map
